import { useCallback } from "react";
import { Link, Outlet, useParams } from "react-router-dom";
import { Alert, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { adminApi } from "../api/endpoints";
import { useApi } from "../hooks/useApi";

export function AdminRequestWorkflow() {
  const { ref } = useParams();
  const { t } = useTranslation();
  const load = useCallback(() => adminApi.requestDetail(ref), [ref]);
  const { data } = useApi(load);
  return <>
    <Alert severity="info" sx={{ mb: 2 }} action={<Button component={Link} to="/administracion/usuarios">{t("admin.requestBackToUsers")}</Button>}>
      {t("admin.requestActingFor", { name: data?.owner?.fullName ?? ref, company: data?.company?.name ?? "" })}
    </Alert>
    <Outlet />
  </>;
}
